module.exports = __webpack_public_path__ + "static/media/2-2.b96c47c1.svg";